import React, { useEffect, useRef } from "react";
import { Box } from "@chakra-ui/react";
import { PencilIcon } from "@heroicons/react/outline";
import { useMutation, useQuery } from "react-query";
import { useTranslation, Trans } from "react-i18next";
import { identity_instance } from "../../apiConfig";
import Loader from "../../common/Loader";
import ErrorMsg from "../ErrorMsg";
import { UserContext } from "../../context";
import { useApiUser } from "../../context/ApiAuthContext";

const getPathDir = (urlString) => {
  if (!urlString) return urlString;
  const url = new URL(urlString);
  return url.pathname.match(/([^/]*)\/*$/)[1];
};
const DocumentIframe = ({
  document,
  // expressions,
  // openExpressionDialog,
  iframeRef,
  isSubmitting,
  onNext,
  onCancel,
}) => {
  const { t } = useTranslation();

  const { userData } = React.useContext(UserContext);
  const documentUrl = document?.metaData?.UrlDocument?.data;
  const documentType = document?.metaData?.DocumentType?.data;
  const documentId = getPathDir(documentUrl);

  const replacements = {
    ...userData.user,
    SignDate: new Date().toDateString(),
  };
  function replaceHB(content) {
    const HBregEx = /(?:\{{2,3}([^{}]+(?=\}{2,3}))\}{2,3})/g;
    const newContent = content.replace(HBregEx, (match, p1) => {
      const replacement = replacements[p1];
      return replacement || p1;
    });
    return newContent;
  }
  const documentQuery = useQuery(["document", documentId], () =>
    identity_instance.get(documentUrl)
  );

  return (
    <Box
      p={2}
      rounded={"lg"}
      bg={"white"}
      h={"full"}
      w={"full"}
      mb={10}
      position={"relative"}
      color={"black"}
    >
      {documentQuery.isLoading && <Loader />}
      {documentQuery.isError && (
        <ErrorMsg
          message={t(
            "error.document_get",
            "Error retrieving required document, please see a staff member for assistance."
          )}
        />
      )}
      {documentQuery.data && (
        <iframe
          ref={iframeRef}
          srcDoc={replaceHB(documentQuery?.data?.data)}
          width="100%"
          height="100%"
        />
      )}
    </Box>
  );
};

export default DocumentIframe;
